import './Icon.scss';

import { b2x } from '@b2x/react/src';

export const iconsNames = [
  'flag',
  'hidden',
  'info',
  'instagram',
  'large-arrow-left',
  'large-arrow-right',
  'linkedin',
  'menu',
  'minus',
  'newsletter',
  'phone',
  'plus',
  'search',
  'small-arrow-down',
  'small-arrow-left',
  'small-arrow-right',
  'small-arrow-up',
  'translate',
  'visible',
  'delete',
  'facebook',
] as const;
export type IconName = (typeof iconsNames)[number];

export type IconSize = 12 | 14 | 16 | 20 | 24 | 25 | 30 | 35 | 48 | 72;

export interface IconProps extends b2x.IconProps<IconName, IconSize> {}

export const Icon = (props: IconProps) => <b2x.Icon {...props} />;

export const isIconName = (name?: string): name is IconName => b2x.isIconName(iconsNames, name);
